// 法语语言包fr.js
export default {
  route: {
    receiveAward: 'Tirer immédiatement',
    congratulation: 'Félicitations',
    name: 'Nom et Prénom',
    phone: 'Numéro de téléphone',
    email: 'Mes achats'
  }
}
